(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("cByPq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $07b3700553c46e4d$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $iFLGW = parcelRequire("iFLGW");

var $N2wHE = parcelRequire("N2wHE");
parcelRequire("lLUSR");

var $lj8Ba = parcelRequire("lj8Ba");

var $1HGFx = parcelRequire("1HGFx");

var $67EyS = parcelRequire("67EyS");
const $07b3700553c46e4d$var$SingleTTNewsPage = ({ singleNewsId: singleNewsId, backLink: backLink, backText: backText })=>{
    const { data: newsItem, isLoading: isLoading } = (0, $iFLGW.default)(singleNewsId);
    const [cropImg, setCropImg] = (0, $dTCkE.useState)("");
    const [cropImgMobile, setCropImgMobile] = (0, $dTCkE.useState)("");
    const [bgBlurImg, setbgBlurImg] = (0, $dTCkE.useState)("");
    const isBigScreen = (0, $67EyS.default)("(min-width: 560px)");
    const [isLoadingImg, setIsLoadingImg] = (0, $dTCkE.useState)(true);
    (0, $dTCkE.useEffect)(()=>{
        async function cropImage() {
            if (newsItem?.mainImage?.url) {
                setCropImg(await (0, $1HGFx.AssetService).assetGetResizedImage(newsItem?.mainImage?.url, 780, 540, (0, $1HGFx.Fit).INSIDE, 80));
                setCropImgMobile(await (0, $1HGFx.AssetService).assetGetResizedImage(newsItem?.mainImage?.url, 680, 480, (0, $1HGFx.Fit).INSIDE, 80));
                setbgBlurImg(await (0, $1HGFx.AssetService).assetGetResizedImage(newsItem?.mainImage?.url, 100, 100, (0, $1HGFx.Fit).INSIDE, 60));
                setIsLoadingImg(false);
            }
        }
        cropImage();
    }, [
        newsItem?.mainImage?.url
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE))).locale("sv");
    return /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
        children: [
            !isLoading && !isLoadingImg && /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                children: [
                    cropImg && /*#__PURE__*/ (0, $a9eYm.jsxs)("section", {
                        className: "relative mx-auto mdplus:mt-6 max-w-2xl overflow-hidden hero-section",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("picture", {
                                children: [
                                    isBigScreen === false && /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                        src: cropImgMobile,
                                        alt: newsItem?.mainImage?.caption ? newsItem?.mainImage?.caption : newsItem?.mainImage?.title,
                                        className: "block w-full max-h-sm object-contain"
                                    }),
                                    isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                        src: cropImg,
                                        alt: newsItem?.mainImage?.caption ? newsItem?.mainImage?.caption : newsItem?.mainImage?.title,
                                        className: "block mx-auto min-h-68 max-h-md object-contain"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: "-z-10 absolute inset-0 bg-blue1100 bg-contain bg-no-repeat bg-center blur-[15px] scale-[2.5]",
                                style: {
                                    backgroundImage: `url(${bgBlurImg}`
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "mx-auto px-3 xl:px-0 pt-4 lg:pt-6 pb-2 lg:pb-0 max-w-2xl",
                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("a", {
                            href: backLink,
                            className: "inline-flex items-center mb-2 hover:underline",
                            children: [
                                /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                    width: 20,
                                    height: 10,
                                    className: "mr-3 w-5 rotate-180 transform",
                                    src: "/Images/Icons/Arrows/arrow-right-black500.svg",
                                    alt: "Ikon pil tillbaka"
                                }),
                                backText
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("section", {
                        className: "lg:my-4 contentSection umbraco-section pressSection pressSingleSection",
                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                            className: "mx-auto px-3 xl:px-0 max-w-2xl pressContainer",
                            children: [
                                newsItem?.title && /*#__PURE__*/ (0, $a9eYm.jsx)("h1", {
                                    className: "text-blue500 lg:text-4xl",
                                    children: newsItem?.title
                                }),
                                newsItem?.published && /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                                    className: "mb-1 text-grey300 date",
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(newsItem?.published).format("YYYY-MM-DD")
                                }),
                                newsItem?.leadTextOrBodyStrip && /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                                    className: "my-3 md:my-5 leading-6 preamble",
                                    children: newsItem?.leadTextOrBodyStrip
                                }),
                                newsItem?.body && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    className: "font-ic leading-6 press-text",
                                    dangerouslySetInnerHTML: {
                                        __html: newsItem?.body
                                    }
                                }),
                                newsItem?.documents && newsItem?.documents.length > 0 && /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $a9eYm.jsx)("h4", {
                                            className: "font-icb",
                                            children: "Dokument"
                                        }),
                                        /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                                            className: "text",
                                            children: newsItem?.documents?.map((document)=>{
                                                return /*#__PURE__*/ (0, $a9eYm.jsx)("a", {
                                                    href: document?.url,
                                                    children: document?.caption
                                                });
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            (isLoading || isLoadingImg) && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex justify-center items-center py-16",
                children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lj8Ba.default), {})
            })
        ]
    });
};
var $07b3700553c46e4d$export$2e2bcd8739ae039 = $07b3700553c46e4d$var$SingleTTNewsPage;

});
parcelRegister("iFLGW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ceee12e71ebb403$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");

var $1HGFx = parcelRequire("1HGFx");
const $9ceee12e71ebb403$var$useSingleTTNews = (newsId)=>{
    return (0, $4cyLg.useQuery)([
        "singleTTNews",
        newsId
    ], ()=>(0, $1HGFx.TtService).ttGetSingleTtNews(newsId).then((response)=>response));
};
var $9ceee12e71ebb403$export$2e2bcd8739ae039 = $9ceee12e71ebb403$var$useSingleTTNews;

});

parcelRegister("67EyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23722fec40a37891$export$2e2bcd8739ae039; });

var $dTCkE = parcelRequire("dTCkE");
const $23722fec40a37891$var$useMediaQuery = (query)=>{
    const [matches, setMatches] = (0, $dTCkE.useState)();
    (0, $dTCkE.useEffect)(()=>{
        const media = window.matchMedia(query);
        if (media.matches !== matches) setMatches(media.matches);
        const listener = ()=>setMatches(media.matches);
        media.addEventListener("change", listener);
        return ()=>media.removeEventListener("change", listener);
    }, [
        query,
        matches
    ]);
    return matches;
};
var $23722fec40a37891$export$2e2bcd8739ae039 = $23722fec40a37891$var$useMediaQuery;

});


})();
//# sourceMappingURL=SingleTTNewsPage.228bb49f.js.map
